var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "menu-svg",
    d: "M4 1C4 0.45 3.55 0 3 0C2.45 0 2 0.45 2 1V5H0V11H6V5H4V1ZM8 15C8 16.3 8.84 17.4 10 17.82V22H12V17.82C13.16 17.41 14 16.31 14 15V13H8V15ZM0 15C0 16.3 0.84 17.4 2 17.82V22H4V17.82C5.16 17.4 6 16.3 6 15V13H0V15ZM20 5V1C20 0.45 19.55 0 19 0C18.45 0 18 0.45 18 1V5H16V11H22V5H20ZM12 1C12 0.45 11.55 0 11 0C10.45 0 10 0.45 10 1V5H8V11H14V5H12V1ZM16 15C16 16.3 16.84 17.4 18 17.82V22H20V17.82C21.16 17.41 22 16.31 22 15V13H16V15Z",
    fill: "#828282"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/Integrations.feacee8d.svg";
export { ForwardRef as ReactComponent };